import React from 'react';

import LibTab from '@material-ui/core/Tab';
import LibTabs from '@material-ui/core/Tabs';
import { withStyles } from '@material-ui/core/styles';

import { string, shape } from 'prop-types';

const tabStyle = {
  labelStyles: {
    fontWeight: 500
  },
  rootStyles: {
    minWidth: '50px !important'
  }
};

const _Tab = ({ ...props }) =>
  <LibTab
    {...props}
    classes={{
      label: props.classes.labelStyles,
      root: props.classes.rootStyles
    }}
  />;

_Tab.propTypes = {
  classes: shape({
    labelStyles: string
  })
};

export const Tab = withStyles(tabStyle)(_Tab);

export const Tabs = ({ ...props }) =>
  <LibTabs variant="fullWidth" fullWidth indicatorColor="primary" {...props} />;

Tabs.muiName = 'Tabs';
Tab.muiName = 'Tab';



// WEBPACK FOOTER //
// ./src/client/shared-components/Tabs/index.js